module.exports = __webpack_public_path__ + "static/img/run2023_mobile_pending.41de6fe9.jpg";